import React from 'react';
import { CircularProgress, Backdrop, Typography } from '@mui/material';

const BusyOverlay = ({ open, message = 'Please wait…' }) => {
  return (
    <Backdrop
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 10,
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
      }}
      open={open}
    >
      <CircularProgress color="inherit" />
      <Typography variant="h6">{message}</Typography>
    </Backdrop>
  );
};

export default BusyOverlay;